import React from 'react';
import styled from 'styled-components';
import { MobxComponent } from '../../../mobx/components';
// @ts-ignore
import uploadcare from 'uploadcare-widget/uploadcare.full.min.js';
// @ts-ignore
import uploadcareTabEffects from 'uploadcare-widget-tab-effects';
import { CoreUtils } from '@lib/common';
import { MenuUploadButton, MenuUploadButtonGroup, MenuUploadContainer, MenuUploadText } from './layout.c';
import { IconNoImage } from './icons';

uploadcare.registerTab('preview', uploadcareTabEffects);
const Wrapper = styled.div`
  border: 2px dashed #ccc;
  border-radius: 4px;
  width: 100%;
  height: 264px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px;
  box-sizing: border-box;
  background-color: #f9f9f9;
`;

const Icon = styled.div`
  font-size: 48px;
  color: #888;
  margin-bottom: 8px;
`;

const Text = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

const Button = styled.button`
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
  padding: 8px 16px;
  color: #FB2F2F;
  border: 1px solid #FB2F2F;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  background: #F5F5F5;
  &:hover {
    background-color: #ff3333;
  }
`;
const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
  margin: 8px;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  color: #ff4b4b;
  border: 1px solid #ff4b4b;
  border-radius: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 0;
`;

interface Props {
    onOpen?: () => void;
    onChange: (files: any) => void;
    onRemove: () => void;
    value: Array<T.Core.Business.BusinessImage | null>;
    onClose?: () => void;
    multi?: boolean;
    multiAmount?: number;
    crop?: string;
    imagesOnly?: boolean;
    imageShrink?: string;
    inputAcceptTypes?: string;
    maxSize?: number;
    settings?: object;
}

interface State { }
export class ImageUploadV2 extends MobxComponent<Props, State> {
    openUploadDialog = () => {
      const { onOpen, onChange, onClose, multi, multiAmount, crop, imagesOnly, imageShrink, inputAcceptTypes, onRemove, settings } = this.props;
  
      if (onOpen) onOpen();
  
      const dialog = uploadcare.openDialog([], "", {
        ...settings,
        multiple: multi,
        multipleMax: multiAmount || 0,
        imagesOnly: imagesOnly,
        crop: crop || "",
        imageShrink: imageShrink,
        inputAcceptTypes: inputAcceptTypes,
        clearable: true,
        previewStep: true
      });
  
      if (onClose) dialog.always(onClose);
  
      dialog.done(async (filesPromise: any) => {
        try {
          const files = [];
  
          if (multi) {
            const promises = filesPromise.files();
            for (const p of promises) {
              const result = await p.done();
              files.push({
                _id: result.uuid,
                name: result.name,
                modifiers: result.cdnUrlModifiers,
              });
            }
          } else {
            const result = await filesPromise.done();
            files.push({
              _id: result.uuid,
              name: result.name,
              modifiers: result.cdnUrlModifiers,
            });
          }
  
          onChange(files);
        } catch (e) {
          console.error(e);
        }
      });
    };
    render() {
        const { onRemove, value} = this.props;
      return (
        <>
            {value.map((item: any, index: any) => (
    
                <MenuUploadContainer>
                    {item ?
                      <a className="inline-block m-t-3" href={CoreUtils.image.uc(value[0])} target="_blank">
                          <img src={CoreUtils.image.uc(value[0], { resize: "x150", format: "auto" })}/>
                      </a>
                      : <IconNoImage /> }
                  
                      {!item && <MenuUploadText>Click below to select image.</MenuUploadText> }
                      <MenuUploadButtonGroup>
                      <MenuUploadButton onClick={this.openUploadDialog}>Upload Image</MenuUploadButton>
                      {item && <MenuUploadButton onClick={() => onRemove()}>Remove</MenuUploadButton> }
                      </MenuUploadButtonGroup>
                </MenuUploadContainer>
                
            ))}
        </>
      );
    }
  }
